import React, { PureComponent, Children, PropTypes, cloneElement } from 'react';
import NotificationSystem from 'react-notification-system';

const NOTIFICATION_DEFAULTS = { position: 'tr', autoDismiss: 2 };

export const NOTIFICATION_CONTEXT_TYPES = {
  onError: PropTypes.func.isRequired,
  onWarning: PropTypes.func.isRequired,
  onInfo: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired
};

/**
 * Provides the notification handler functions to the children elements
 */
export default class NotificationSystemProvider extends PureComponent {
  static propTypes = {
    defaultOptions: PropTypes.object
  };

  static defaultProps = {
    defaultOptions: null
  };

  static childContextTypes = NOTIFICATION_CONTEXT_TYPES;

  getChildContext() {
    return {
      onError: this._handleError,
      onWarning: this._handleWarning,
      onInfo: this._handleInfo,
      onSuccess: this._handleSuccess
    };
  }

  _handleNotification = (level, message, options) => {
    const { notificationSystem } = this.refs;
    const { defaultOptions } = this.props;

    if (message instanceof Error) {
      console.error(message);
      message = message.message;
    }

    if (notificationSystem) {
      notificationSystem.addNotification({ ...NOTIFICATION_DEFAULTS, ...defaultOptions, level, message, ...options });
    } else {
      console[ level ].apply(console, arguments); // eslint-disable-line
    }
  };

  _handleError = (message, options) => this._handleNotification('error', message, options);
  _handleWarning = (message, options) => this._handleNotification('warning', message, options);
  _handleInfo = (message, options) => this._handleNotification('info', message, options);
  _handleSuccess = (message, options) => this._handleNotification('success', message, options);

  render() {
    const { children, defaultOptions, ...rest } = this.props;

    return (
      <div {...rest}>
        {
          Children.map(children,
            child => cloneElement(child, {
              onError: this._handleError,
              onWarning: this._handleWarning,
              onInfo: this._handleInfo,
              onSuccess: this._handleSuccess
            })
          )
        }
        <NotificationSystem key="notifications" ref="notificationSystem"/>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/js/NotificationSystemProvider.jsx